<template>
  <!--普通模板-->
  <div class="general" style="margin-top: 20px">
    <el-table
      :data="dataList"
      tooltip-effect="dark"
      class="tpl-table data-list"
      v-loading="loadingList"
      style="height: calc(100vh - 240px)"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '500',
      }"
    >
      <el-table-column
        label="模板名称"
        prop="tplName"
        :show-overflow-tooltip="true"
      />
      <el-table-column label="操作" width="100px">
        <div slot-scope="scope" class="action pointer">
          <nuxt-link
            :to="{
              path: '/tpl/add/apply',
              query: { tplId: scope.row.tplId, isAuth: 1 },
            }"
            class="color-success span"
            >使用</nuxt-link
          >
          <!--<span @click="$router.push({path: '/tpl/add/general', query:{tplId: scope.row.tplId}})" class="color-success">编辑</span>-->
          <!--<span @click="delTpl(scope.row)" class="color-danger">删除</span>-->
        </div>
      </el-table-column>
    </el-table>

    <el-row class="pageation row">
      <el-col :span="20" class="page-flex-end">
        <el-pagination
          v-if="paged.total > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :total="paged.total"
          :current-page.sync="paged.pageNum"
          :page-size="paged.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          layout="sizes, prev, pager, next, total"
        />
        <el-go
          :page-size="paged.pageSize"
          :total="paged.total"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { ApiMethods } from '@/assets/js/http-serve/http-methods';
import ElGo from '../../components/go/Go';

export default {
  name: 'authorization',
  components: { ElGo },
  data () {
    return {
      dataList: [],
      paged: { itemPage: 1, pageSize: 10 },
      loadingList: true,
    };
  },
  methods: {
    handleCurrentChange: function (val) {
      this.paged.pageNum = val;
      this.queryList();
    },
    handleSizeChange: function (val) {
      this.paged.pageSize = val;
      this.queryList();
    },
    queryList () {
      const param = { itemPage: this.paged.pageNum, pageSize: this.paged.pageSize };
      ApiMethods.TemplateController.authTpl(param).then(result => {
        if (!result.success) return this.$message.error(result.description || this.$tip);
        this.dataList = result.data;
        this.paged = { pageNum: result.pageNum, pageSize: result.pageSize, pages: result.pages, total: result.total };
      }).finally(() => this.loadingList = false);
    },
  },
  created () {
    this.queryList();
  },
};
</script>

<style lang="less" scoped>
.general {
  max-width: 1200px;
  margin: 0 auto;
}

.tpl-table {
  border: 1px solid #ebebeb;
  border-bottom: 0;

  .action span {
    margin-right: 10px;
    cursor: pointer;
  }

  .action .span {
    margin-right: 10px;
  }
}

.pageation {
  padding: 30px 10px 20px 10px;
  border-top: 0;
  min-height: 85px;
}
</style>



// WEBPACK FOOTER //
// pages/tpl/authorization.vue